import { atom } from "jotai";

interface INTERVIEWStateInterface {
  id: string;
  interviewee?: string;
  company?: string;
  title?: string;
  email?: string;
  phone?: string;
  communication?: string;
  templateID?: string;
  status: "draft" | "published";
  audio?: AudioArtifact;
  transcripts?: any[];
  notes?: any;
  user?: any;
  hasUploaded: boolean;
  findings?: any[];
  selectedFinding: any;
  speakerDictionary?: any[];
  speakerLibrary?: any[];

  placeholderFinding: any;
}

export const INITIAL_INTERVIEW_ATOM_VALUE: INTERVIEWStateInterface = {
  id: "",
  hasUploaded: false,
  status: "draft",
  speakerLibrary: [],
  speakerDictionary: [],
  selectedFinding: {},
  placeholderFinding: {}
};

export const interviewAtom = atom(INITIAL_INTERVIEW_ATOM_VALUE);

export function setupDictionary(dictionary, set) {
  set((INTERVIEW) => {
    return {
      ...INTERVIEW,
      speakerDictionary: dictionary
    };
  });
}

export function clearSpeakerAndDictionaryData(set) {
  set((INTERVIEW) => {
    return {
      ...INTERVIEW,
      speakerDictionary: [],
      speakerLibrary: []
    };
  });
}

export function setupLibraryAndDictionary(library, buffer, set) {
  set((i) => {
    return {
      ...i,
      speakerLibrary: buffer,
      speakerDictionary: library
    };
  });
}

export function setupLibrary(library, set) {
  set((INTERVIEW) => {
    return {
      ...INTERVIEW,
      speakerLibrary: library
    };
  });
}
